<input class="searchbox" placeholder="{{'SEARCH'| translate}}" type=text [(ngModel)]="searchText">

<div class="container-table" [ngClass]="{'ionic' : useIonic}">
    <table class="hardman" style="width:100%">
        <tr class="dark">
            <th class="header message">{{'CMREVENTSTABLE.EVENT' | translate}}</th>
            <th class="header datehour">{{'CMREVENTSTABLE.EVENT_AT' | translate}}</th>
            <th class="header alias">{{'CMREVENTSTABLE.USER' | translate}}</th>
            <th class="header info"></th>
        </tr>
        <tr *ngFor="let item of getEvents() | filter:searchText | sortBy:'-eventAt' | slice:0:sliceCount" [ngClass]="item.cmrEventType">
            <td class="message">{{ item.event }}</td>
            <td class="datehour">
                <datehour-viewer [value]="item.eventAt" [showOriginal]="false" [showTimeZone]="false">
                </datehour-viewer>
            </td>
            <td class="alias">
                <span class="only-alias">{{item.alias}}</span>
                <button-link class="link-alias" variant="action" (linkClick)="onClickUser(item)">
                    {{item.alias}}</button-link>
            </td>
            <td class="info">
                <i class="fa fa-info-circle" aria-hidden="true" (click)="onClickInfo(item, $event)"></i>
            </td>
        </tr>
        <button class="slice-button" (click)="onSliceMore($event)" *ngIf="sliceCount<itemsCount">
            {{'GENERAL.SLICE.BUTTON' | translate:{ sliceCount: sliceCount, itemsCount:itemsCount} }}
        </button>
    </table>
</div>

<!-- Detall de l'event (mida mòbil): usuari, moment i missatge complet -->
<div class="event-info-backdrop" *ngIf="selectedEvent != null" (click)="onCloseInfo()">
    <div class="event-info-popup" [ngClass]="selectedEvent.cmrEventType" (click)="$event.stopPropagation()">
        <button class="event-info-close" (click)="onCloseInfo()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <div class="event-info-header">
            <span class="event-info-user">{{ selectedEvent.alias }}</span>
            <datehour-viewer class="event-info-datehour" [value]="selectedEvent.eventAt" [showOriginal]="false"
                [showTimeZone]="false"></datehour-viewer>
        </div>
        <div class="event-info-message">{{ selectedEvent.event }}</div>
    </div>
</div>
